import React, { Component } from 'react'
import { array, func, string } from 'prop-types'
import SameSupport from '../../../assets/img/same_support.png'
import { Marker } from 'react-mapbox-gl'
import { SameSupportCount } from '../styles/ClustersStyles'

class SameSupportCluster extends Component {
  render() {
    const { coordinates, signs } = this.props
    return (
      <Marker
        coordinates={this.props.coordinates}
        className={`clusterMarker ${this.props.category}`}
      >
        <div
          onMouseEnter={() =>
            this.props.handleUpdateInfobox(coordinates, signs, 'sameSupport')
          }
          onClick={() =>
            this.props.handleUpdateInfobox(coordinates, signs, 'sameSupport')
          }
          className="sameSupportLocationContainer"
        >
          <img
            id="MarkerImage"
            className="activeMarker"
            src={SameSupport}
            alt="Signs on same support"
          />
          <SameSupportCount
            bgColor={
              this.props.clusterColor
                ? this.props.clusterColor
                : this.props.theme
            }
          >
            {this.props.signs.length}
          </SameSupportCount>
        </div>
      </Marker>
    )
  }
}

SameSupportCluster.propTypes = {
  coordinates: array.isRequired,
  signs: array.isRequired,
  theme: string.isRequired,
  handleUpdateInfobox: func.isRequired,
}

export default SameSupportCluster



// WEBPACK FOOTER //
// ./src/components/Map/Markers/SameSupportCluster.jsx